import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
// import moment from "moment";
import "regenerator-runtime/runtime";

import Document from "../../_shark_models/Document";
import ResinSystem from "../../_shark_models/ResinSystem";
import SiteInfoSheet from "../../_shark_models/SiteInfoSheet";

import { documentManager } from "./documentManager";
import { folderManager } from "./folderManager";
// import followUpManager from "./followUpManager";
// import { quotationManager } from "./quotationManager";
// import { userManager } from "./userManager";
// import { visitManager } from "./visitManager";

class SiteInfoSheetManager extends Controller {
	constructor () {
		super("siteInfoSheetManager");
		this.remoteClassName = "site-info-sheet";
	}

	async checkFolders (guid) {
		const rd = NousCore.api.createRequest({ item: { createOnMissing: true, guid } });
		const requestedAction = "check-folders";


		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}


	checkForSave () {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
		const validationErrors = currSiteInfoSheet.validate();
		const isValid = currSiteInfoSheet.isValid();
	
		if (!isValid) {
			//Dave: Questa roba non dovrebbe stare qui, ma tutta questa funzione non dovrebbe
			Shark.render();
			alert("Attenzione, si sono verificati i seguenti errori:\n\n" + validationErrors.join("\n"));
			return false;
		}
		else {
			return true;
		}
	}

	checkSingleContactFolders (siteInfoSheet, contactRole/*, siteInfoSheetFolder*/) {
		const currUser = Shark.get("currUser");

		return folderManager.getByReference(siteInfoSheet.registry[`${contactRole}Guid`], "client")
		.then(customerFolderResponse => {
			if (customerFolderResponse.data.length > 0) {
				return {
					guid: customerFolderResponse.data[0].guid,
					roleInParent: contactRole,
				};
			}
			else {
				if (siteInfoSheet.registry[`${contactRole}Guid`] !== "") {
					const clientFolder = Shark.getInstance("Folder", {
						clientGuid: siteInfoSheet.registry[`${contactRole}Guid`],
						name: siteInfoSheet.registry[`${contactRole}Name`],
						ownerGuid: currUser.guid,
						parentGuid: currUser.clientsFolderGuid,
						referenceGuid: siteInfoSheet.registry[`${contactRole}Guid`],
						referenceType: "client",
						status: 1,
						type: "client",
					});
					
					return folderManager.save(clientFolder)
					.then(() => {
						return {
							guid: clientFolder.guid,
							roleInParent: contactRole,
						};
					});
				}
				else {
					return {
						guid: "",
						roleInParent: "",
					};
				}
			}
		});
	}

	checkContactFolders (siteInfoSheet, siteInfoSheetFolder) {
		const newParentGuids = [];
		// const currUser = Shark.get("currUser");

		this.checkSingleContactFolders(siteInfoSheet, "customer")
		.then(customerFolderResponse => {
			if (customerFolderResponse.guid !== "") {
				newParentGuids.push(customerFolderResponse);
			}

			this.checkSingleContactFolders(siteInfoSheet, "designer")
			.then(designerFolderResponse => {
				if (designerFolderResponse.guid !== "") {
					newParentGuids.push(designerFolderResponse);
				}

				this.checkSingleContactFolders(siteInfoSheet, "endUser")
				.then(endUserFolderResponse => {
					if (endUserFolderResponse.guid !== "") {
						newParentGuids.push(endUserFolderResponse);
					}

					if (JSON.stringify(siteInfoSheetFolder.parentGuids) !== JSON.stringify(newParentGuids)) {
						console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA Devo cambiare", siteInfoSheetFolder.parentGuids, newParentGuids);
						siteInfoSheetFolder.set("parentGuids", newParentGuids);
					}

					if (siteInfoSheetFolder.isDirty(["name", "parentGuids"])) {
						folderManager.save(siteInfoSheetFolder)
						.then(siteInfoSheetFolderUpdateResponse => {
							console.log("Ho aggiornato la cartella", siteInfoSheetFolderUpdateResponse);
						});
					}
				});
			});
		});
	}

	createPremiseDestination () {
		return Shark.getInstance("__smart__", {
			premiseDestination: "",
			premiseNote: "",
			substrateType: "",
			systems: [this.createSystem()]
		});
	}

	createSystem () {
		// const newSystem = Shark.getInstance("__smart__", {
		// 	area: 0,
		// 	jobType: "",
		// 	jobTypeSpec: "",
		// 	otherSystemNote: "",
		// 	scope: "",
		// 	system: "",
		// 	systemNote: "",
		// 	preparation: "",
		// 	proposalGroup: -1,
		// 	thickness: 0,
		// 	__isNewJob: false,
		// 	__isOtherSystem: false,
		// 	__isRemakeJob: false,
		// });

		// newSystem.onDataChanged = function (data) {
		// 	switch (data.property) {
		// 		case "system": {
		// 			//Dave: Questa cosaì è pericolosissima, dovrei darre un ID a tutti i Sistemi
		// 			const wasOtherSystem = this.__isOtherSystem;
		// 			this.__isOtherSystem = data.newValue === "ALTRO";

		// 			if (wasOtherSystem !== this.__isOtherSystem) {
		// 				//Dave: Anche il render da qui non mi piace
		// 				Shark.render();
		// 			}
		// 			break;
		// 		}
		// 		case "jobType":
		// 			this.__isNewJob = data.newValue === "new";
		// 			this.__isRemakeJob = data.newValue === "remake";
		// 			break;
		// 	}
		// 	console.log(data, this);
		// };

		const newSystem = new ResinSystem();

		return newSystem;
	}

	delete (item, deleteReason, sisName) {
		const rd = NousCore.api.createRequest({ item: { guid: item.guid, deleteReason, sisName }});
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async getByGuid (guid, siteInfoSheetToFill = null) {
		const rd = NousCore.api.createRequest({ item: { guid } });
		const action = "get-by-guid";

		return NousCore.api.send(`site-info-sheet/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							if (siteInfoSheetToFill) {
								siteInfoSheetToFill.import(data.items[0]);
								siteInfoSheetToFill.clean();
							}
							else {
								siteInfoSheetToFill = new SiteInfoSheet(data.items[0]);
							}
	
							return {
								data: siteInfoSheetToFill,
								requestedAction: action,
								status: "ok",
							};
						}
						else {
							return {
								data: null,
								requestedAction: action,
								status: "ko",
							};
						}
					case 99:
						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-list";

		if (range) {
			rd.range = range;
		}

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						let siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						if (incrementalRequest) {
							siteInfoSheetList = [...Shark.get("siteInfoSheetList"), ...siteInfoSheetList];
						}

						Shark.set({
							siteInfoSheetList,
							__siteInfoSheetListNeedFurtherLoad: data.availableItemCount > siteInfoSheetList.length,
							__availableFurtherItems: data.availableItemCount - siteInfoSheetList.length,
						});

						return {
							data: siteInfoSheetList,
							requestedAction,
							status: "ok"
						};
					}
					case 404:
						return {
							data: null,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	reindexSystem (currSiteInfoSheet) {
		currSiteInfoSheet.systems.forEach((item, index) => {
			item.__index = index;
	
			item.systems.forEach((system, systemIndex) => {
				system.__subIndex = systemIndex;
			});
		});
	}

	revertStatus (item, newStatus, reason = "") {
		const rd = NousCore.api.createRequest({ item: { reason, guid: item.guid, newStatus }});
		const requestedAction = "revert-status";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
	
	manageSaveUpdate (siteInfoSheet, preSaveAttachments) {
		const documentToDeleteList = preSaveAttachments.filter(item => item.__deletePending);//.map(item => item);
		if (documentToDeleteList.length > 0) {
			documentManager.delete2(documentToDeleteList);
		}

		const sisGuidForFolder = siteInfoSheet.revision === 0 ? siteInfoSheet.guid : siteInfoSheet.revisionReferenceGuid;

		folderManager.getByReference(sisGuidForFolder)
		.then(siteInfoSheetFolderResponse => {
			const siteInfoSheetFolder = siteInfoSheetFolderResponse.data.filter(item => item.type === "siteInfoSheet")[0];
			const siteInspectionFolder = siteInfoSheetFolderResponse.data.filter(item => item.type === "siteInspection")[0];

			if (siteInfoSheetFolder) {
				let updatedFolderName = siteInfoSheet.getAutoFolderName();

				if (siteInfoSheetFolder.name !== updatedFolderName) {
					siteInfoSheetFolder.set("name", updatedFolderName);
				}

				this.checkContactFolders(siteInfoSheet, siteInfoSheetFolder);
			}

			if (siteInspectionFolder) {
				this.saveAttachments(preSaveAttachments, siteInspectionFolder)
				.then(attachmentResponse => {
					console.log("dopo", siteInfoSheet.attachmentsGuids, attachmentResponse);
					const documentToDeleteGuidList = documentToDeleteList.map(item => item.guid);

					siteInfoSheet.attachmentsGuids = siteInfoSheet.attachmentsGuids.filter(item => !documentToDeleteGuidList.includes(item));
					siteInfoSheet.attachmentsGuids.push(...attachmentResponse);
					this.updateAttachmentGuids(siteInfoSheet);

					documentManager.getList(siteInspectionFolder)
					.then(siteInspectionFolderDocumentsResponse => {
						const documentList = siteInspectionFolderDocumentsResponse.data;

						//Dave: fin quando non processo tutte le SIS nel DB, devo eliminare anche le picture (che non sono legate dal guid ma dall'url)
						documentList.forEach(document => {
							if (document.source === "siteInfoSheet") {
								if (!siteInfoSheet.attachmentsGuids.includes(document.guid)) {
									const existing = Utils.safp(siteInfoSheet.pictures, "url", document.fileURL);
									if (!existing) {
										//Dave.ToDo: Meglio fare un array e cancellarli tutti insieme
										documentManager.delete(document)
										.then(() => {
											console.log("Cancellato il file", document);
										});
									}
								}
							}
						});
					});
				});
			}
		});
	}

	save (siteInfoSheet) {
		const rd = NousCore.api.createRequest({ item: siteInfoSheet.export() });
		const action = siteInfoSheet.guid === "" ? "insert" : "update";
		const preSaveAttachments = siteInfoSheet.__attachments;

		return NousCore.api.send(`site-info-sheet/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						siteInfoSheet.import(data.items[0]);
						siteInfoSheet.clean();
	
						this.manageSaveUpdate(siteInfoSheet, preSaveAttachments);
						//Visto che siamo lato IPM è sicuramente un update, verifico se va cambiato qualcosa
						// Non è vero > lato IPM viene sempre fatta una nuova revisione, quindi è un Insert, ma la roba dopo il save va fatta come per gli Update.

						siteInfoSheetManager.emit("saved");
						return {
							data: siteInfoSheet,
							requestedAction: action,
							status: "ok"
						};
					case 99:
						siteInfoSheetManager.emit("saveError");
						return {
							data: "",
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

	async saveAttachments (attachmentList, destinationFolder) {
		return await Promise.all(attachmentList.filter(item => item.guid === "").map(async item => {
			item.set({
				folderGuid: destinationFolder.guid,
			});
			console.log("dentro prima", item);

			return await documentManager.save(item)
			.then(documentSaveResponse => {
				return documentSaveResponse.data.guid;
			});
		}));
	}

	async saveClientSolvencySettings (siteInfoSheet) {
		const rd = NousCore.api.createRequest({ item: siteInfoSheet.export() });
		const action = "save-client-solvency-settings";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						siteInfoSheet.clean();
	
						return {
							data: siteInfoSheet,
							requestedAction: action,
							status: "ok"
						};
					case 99:
						return {
							data: "",
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

	//Dave: Comunque potrei fare il save Async prima di salvare il Documento così non devo fare l'update
	updateAttachmentGuids (siteInfoSheet) {
		const rd = NousCore.api.createRequest({ item: siteInfoSheet.export() });
		const requestedAction = "update";//DAve: ci vorrebbe un metodo API apposta per farlo.
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				console.log("ho salvato gli attachment guids sis", siteInfoSheet);
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok"
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	//Dave: presumo che questo si possa adattare ad essere unico anche con le CSC
	uploadPicture (target) {
		return NousCore.api.uploadFiles(target, "site-info-sheet/upload-picture")
		.then(jsonData => {
			const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
			const savedFiles = jsonData.payload.items;

			savedFiles.forEach(savedFile => {
				switch (savedFile.rc) {
					case 1: {
						const fileType = savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1).toLowerCase();

						const newDocument = new Document({
							fileType,
							fileURL: "/" + savedFile.filePath,
							fileSize: savedFile.size,
							name: savedFile.name,
							// role: "",
							// section: "",
							source: "siteInfoSheet",
							status: 1,
							thumbnailURL: savedFile.thumbnailFilPath ? "/" + savedFile.thumbnailFilPath : ["jpg", "jpeg", "png"].indexOf(fileType) > -1 ? "/" + savedFile.filePath : "/" + documentManager.getIconFromExtension(fileType),
						});

						currSiteInfoSheet.__dirtyProperties.push({ property: "__attachments", originalValue: [...currSiteInfoSheet.__attachments] });
						currSiteInfoSheet.__attachments.push(newDocument);

						break;
					}
					case 95:
						break;
					default:
						alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
				}
			});

			Shark.render();
		});
	}

	uploadQuotation (target) {
		return NousCore.api.uploadFiles(target, "site-info-sheet/upload-quotation")
		.then(function (jsonData) {
			const savedFiles = jsonData.payload.items;

			return {
				data: savedFiles,
				requestedAction: "upload-quotation",
				status: "ok"
			};
		});
	}






	
	archive (guid) {
		const rd = NousCore.api.createRequest({ item: { guid } });
		const action = "archive";

		return NousCore.api.send(`site-info-sheet/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheet = Shark.getInstance("SiteInfoSheet", data.items[0]);

						return {
							data: siteInfoSheet,
							requestedAction: action,
							status: "ok",
						};
					}
					case 99:
						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	getByGuidWithRevisions (guid) {
		const rd = NousCore.api.createRequest({ item: { guid } });
		const action = "get-by-guid-with-revisions";

		return NousCore.api.send(`site-info-sheet/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							const siteInfoSheetWithRevisions = Shark.getInstanceList("SiteInfoSheet", data.items);
							return {
								data: siteInfoSheetWithRevisions,
								status: "ok",
							};
						}
						else {
							return {
								data: [],
								status: "ko",
							};
						}
					case 99:
						return {
							data: null,
							status: "ko",
						};
				}
			}
		});
	}

	getByVisitGuid (userGuid, visitGuid) {
		const rd = NousCore.api.createRequest({ item: { userGuid, visitGuid } });

		return NousCore.api.send("site-info-sheet/get-by-visit-guid", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.referenceDate > b.referenceDate) {
								return 1;
							}
							else if (a.referenceDate < b.referenceDate) {
								return -1;
							}
						});

						return {
							data: siteInfoSheetList,
							status: "ok"
						};
					}
					case 404:
						return {
							data: null,
							status: "ko"
						};
				}
			}
		});
	}

	getList () {
		const rd = NousCore.api.createRequest();

		return NousCore.api.send("site-info-sheet/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.updatedAt < b.updatedAt) {
								return 1;
							}
							else if (a.updatedAt > b.updatedAt) {
								return -1;
							}
						});

						const siteInfoSheetRecap = {
							0: 0,//waiting
							1: 0,//pending
							4: 0,//Uploaded
						};
						
						//{0: 5, 1: 9, 2: 0, 3: 0, 4: 2}
						siteInfoSheetList.forEach(item => {
							// if (siteInfoSheetRecap.hasOwnProperty(item.extraData.quotation.status)) {
							if (Object.prototype.hasOwnProperty.call(siteInfoSheetRecap, item.extraData.quotation.status)) {
								siteInfoSheetRecap[item.extraData.quotation.status]++;
							}
						});

						const siteInfoSheetRequiresAttention = siteInfoSheetList.filter(item => item.extraData.quotation.status < 1);
						const siteInfoSheetRequiresAttentionCount = siteInfoSheetRequiresAttention.length;
						const latestSiteInfoSheetList = siteInfoSheetRequiresAttention.slice(0, 5);

						console.log("siteInfoSheetList", {siteInfoSheetRecap, siteInfoSheetList, latestSiteInfoSheetList});
						Shark.set({
							latestSiteInfoSheetList,
							siteInfoSheetList,
							siteInfoSheetRecap,
							siteInfoSheetRequiresAttentionCount,
						});

						siteInfoSheetManager.emit("listChanged");
						return {
							data: siteInfoSheetList,
							requestedAction: "get-list",
							status: "ok"
						};
					}
					case 404:
						siteInfoSheetManager.emit("listGetError");
						return {
							data: null,
							requestedAction: "get-list",
							status: "ko"
						};
				}
			}
		});
	}

	getListByClient (client) {
		const rd = NousCore.api.createRequest({ item: { clientGuid: client.guid } });

		// rd.payload = {
		// 	range: {
		// 		first: 0,
		// 		length: 100
		// 	}
		// };

		NousCore.api.send("site-info-sheet/get-list-by-client", rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.referenceDate < b.referenceDate) {
								return 1;
							}
							else if (a.referenceDate > b.referenceDate) {
								return -1;
							}
						});

						console.log({ siteInfoSheetList });
						Shark.set("siteInfoSheetList", siteInfoSheetList);

						siteInfoSheetManager.emit("listChanged");
						break;
					}
					case 404:
						siteInfoSheetManager.emit("listGetError");
						break;
				}
			}
		});
	}

	getListByAgent (user) {
		const rd = NousCore.api.createRequest({ item: { userGuid: user.guid } });

		// rd.payload = {
		// 		range: {
		// 			first: 0,
		// 			length: 6
		// 		}
		// 	};

		NousCore.api.send("site-info-sheet/get-list-by-agent", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.referenceDate > b.referenceDate) {
								return -1;
							}
							else if (a.referenceDate < b.referenceDate) {
								return 1;
							}
						});

						const siteInfoSheetListProvinceForFilter = new Set();

						siteInfoSheetList.forEach(item => item.registry.clientProvince !== "" ? siteInfoSheetListProvinceForFilter.add(item.registry.clientProvince) : false);

						Shark.set({
							siteInfoSheetList,
							siteInfoSheetListProvinceForFilter: Array.from(siteInfoSheetListProvinceForFilter).sort(),
							latestSiteInfoSheetList: siteInfoSheetList.slice(0, 4)
						});

						// siteInfoSheetManager.emit("listChanged");
						break;
					}
					case 404:
						siteInfoSheetManager.emit("listGetError");
						break;
				}
			}
		});
	}

	getListByAgentAndClient (userGuid, clientGuid) {
		const rd = NousCore.api.createRequest({ item: { userGuid: userGuid, clientGuid: clientGuid } });

		NousCore.api.send("site-info-sheet/get-list-by-agent-and-client", rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.referenceDate > b.referenceDate) {
								return 1;
							}
							else if (a.referenceDate < b.referenceDate) {
								return -1;
							}
						});

						console.log("siteInfoSheetList", siteInfoSheetList);
						Shark.set("siteInfoSheetList", siteInfoSheetList);

						siteInfoSheetManager.emit("listChanged");
						break;
					}
					case 404:
						siteInfoSheetManager.emit("listGetError");
						break;
				}
			}
		});
	}


	setStatus (siteInfoSheet) {
		const rd = NousCore.api.createRequest({ item: { guid: siteInfoSheet.guid, status: siteInfoSheet.status } });

		return NousCore.api.send("site-info-sheet/set-status", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						// if (siteInfoSheet instanceof SiteInfoSheet) {
						if (typeof siteInfoSheet.import === "function") {
							siteInfoSheet.import(data.items[0]);
							siteInfoSheet.clean();
						}

						return {
							data: siteInfoSheet,
							requestedAction: "set-status",
							status: "ok"
						};
					case 404:
						return {
							data: null,
							error: data.error,
							requestedAction: "set-status",
							status: "ko"
						};
				}
			}
		});
	}
}

const siteInfoSheetManager = new SiteInfoSheetManager();



//Dave: Questo non starebbe meglio nel quotationManager?
// buttami (target) {
// 	return NousCore.api.uploadFiles(target, "site-info-sheet/save-quotation")
// 	.then(function (jsonData) {
// 		const savedFiles = jsonData.payload.items;

// 		//Dave: TUtta questa roba sotto non mi piace perché non ha senso che sia un loop. E non returna secco, costringendomi a fare tutto qui roba che non dovrebbe stare qui
// 		savedFiles.forEach(savedFile => {
// 			switch (savedFile.rc) {
// 				case 1: {
// 					const currSiteInfoSheet = Shark.get("currSiteInfoSheet");

// 					currSiteInfoSheet.extraData.quotation.pdfURL = savedFile.filePath;
// 					currSiteInfoSheet.extraData.quotation.status = currSiteInfoSheet.extraData.quotation.handDelivered ? 4 : 1;
// 					currSiteInfoSheet.extraData.quotation.sendingDate = moment().utc().format(Shark.get("dateISOFormat"));

// 					let receiverGuid = currSiteInfoSheet.registry.receiver !== "customer" ? currSiteInfoSheet.registry[`${currSiteInfoSheet.registry.receiver}Guid`] : currSiteInfoSheet.clientGuid;

// 					const currUser = Shark.get("currUser");
// 					const currQuotationData = Shark.get("currQuotationData");
// 					//Dave: Forse il quotation dovrebbe esser gestito dal quotationManager?
// 					// const newQuotation = Shark.getInstance("Quotation", {
// 					// 	clientGuid: receiverGuid,//currSiteInfoSheet.clientGuid,
// 					// 	code: currQuotationData.number,
// 					// 	extraData: {
// 					// 		confirmData: {
// 					// 			conditions: "",
// 					// 			pictures: [],
// 					// 			timeSpanAndApplicatorTeam: {
// 					// 				applicatorTeamId: "",
// 					// 				timeSpanEnd: "0000-00-00 00:00:00",
// 					// 				timeSpanStart: "0000-00-00 00:00:00",
// 					// 			},
// 					// 			userGuid: ""
// 					// 		},
// 					// 		handDelivered: currSiteInfoSheet.extraData.quotation.handDelivered,
// 					// 		relatedGuids: {
// 					// 			clientGuid: receiverGuid,//currSiteInfoSheet.extraData.relatedGuids.clientGuid,
// 					// 			siteInfoSheetGuid: currSiteInfoSheet.guid,
// 					// 			visitGuid: currSiteInfoSheet.extraData.relatedGuids.visitGuid,
// 					// 		},
// 					// 		refuseReason: "",
// 					// 		siteLocation: {
// 					// 			address: "",
// 					// 			city: "",
// 					// 			name: "",
// 					// 			province: "",
// 					// 			region: "",
// 					// 			zip: "",
// 					// 			personInCharge: {
// 					// 				name: "",
// 					// 				eMail: "",
// 					// 				phone: ""
// 					// 			},
// 					// 		}
// 					// 	},
// 					// 	pdfURL: currSiteInfoSheet.extraData.quotation.pdfURL,
// 					// 	referenceDate: currQuotationData.date,
// 					// 	revision: currQuotationData.revision,
// 					// 	revisionReferenceGuid: currQuotationData.revisionReferenceGuid,
// 					// 	sendingDate: moment(),
// 					// 	siteInfoSheetData: {
// 					// 		agentGuid: currSiteInfoSheet.userGuid,
// 					// 		agentName: currSiteInfoSheet.__agentName,
// 					// 		clientCommoditySector: currSiteInfoSheet.registry.clientCommoditySector,
// 					// 		clientName: currSiteInfoSheet.registry.clientName,
// 					// 		clientProvince: currSiteInfoSheet.registry.clientProvince,
// 					// 		referenceDate: currSiteInfoSheet.referenceDate.format(Shark.get("dateISOFormat")),
// 					// 		systems: JSON.parse(currSiteInfoSheet.export().systems),
// 					// 	},
// 					// 	siteInfoSheetGuid: currSiteInfoSheet.guid,
// 					// 	status: currSiteInfoSheet.extraData.quotation.status,
// 					// 	userGuid: currUser.guid,
// 					// });
					
// 					console.log(newQuotation);
// 					quotationManager.save(newQuotation)
// 					.then(jsonResponse => {
// 						currSiteInfoSheet.extraData.quotation.guid = jsonResponse.data.guid;
// 						currSiteInfoSheet.extraData.relatedGuids.quotationGuid = jsonResponse.data.guid;
// 						console.log(currSiteInfoSheet);
// 						siteInfoSheetManager.save(currSiteInfoSheet);

// 						visitManager.getByClientGuid(currSiteInfoSheet.clientGuid)
// 						.then(getVisitResponse => {
// 							const visit = getVisitResponse.data[0];

// 							if (visit) {
// 								if (visit.extraData.quotations) {
// 									visit.extraData.quotations.push({guid: newQuotation.guid, status: newQuotation.status});
// 								}
// 								else {
// 									visit.extraData.quotations = [{guid: newQuotation.guid, status: newQuotation.status}];
// 								}

// 								visitManager.save(visit);
// 							}
// 						});

// 						//Dave.Warn: sono abbastanza convinto che questa roba sia orribile
// 						const newRevisionQuotation = Shark.get("newRevisionQuotation");
// 						if (newRevisionQuotation && newRevisionQuotation.guid !== "") {
// 							quotationManager.archive(newRevisionQuotation.guid);
// 							quotationManager.getList();
// 							Shark.set({newRevisionQuotation: null});
// 						}

// 						const quotationAgent = Utils.safp(Shark.get("userList"), "guid", currSiteInfoSheet.userGuid);
						
// 						const nextStepContent = currSiteInfoSheet.extraData.quotation.handDelivered ? "<strong>Ricordati che hai chiesto di consegnare a mano questo preventivo.</strong>" : "Riceverai un'eMail quando il preventivo otterrà un riscontro dal cliente."
						
// 						const body = `BuonGiorno ${quotationAgent.firstName},
						
// 							questa eMail per comunicare che è stato caricato ${(currSiteInfoSheet.extraData.quotationRevisions && currSiteInfoSheet.extraData.quotationRevisions.length > 0) ? "<strong>un nuovo preventivo</strong>" : "il preventivo"} con numero <strong>${currQuotationData.number}</strong>, relativo alla scheda informativa del <strong>${currSiteInfoSheet.__referenceDateLabel}</strong> per <strong>${currSiteInfoSheet.registry.clientName}</strong>.
		
// 							Puoi visualizzare il Preventivo <a href="${Shark.get("__cdnURL")}/${newQuotation.pdfURL}">cliccando qui</a>.
							
// 							Puoi visualizzare le Schede Informative <a href="${Shark.get("agentAppURL")}/#quotationListView">cliccando qui</a>.

// 							${nextStepContent}
		
// 							Buona Giornata,
// 							IPM HUB
// 						`;
		
// 						const currMessage = Shark.getInstance(null, {
// 							body,
// 							senderEMail: currUser.email,
// 							senderName: currUser.__fullName,
// 							subject: "IPM HUB | Preventivo inserito",
// 							receiverEMail: quotationAgent.email,
// 							receiverName: quotationAgent.__fullName,
// 						});
// 						userManager.sendMessage(currMessage);


// 						//const currQuotationData = Shark.get(", "currQuotationData"]);

// 						//Questa roba sta diventando un casino, troppi incroci e chiamate nastosce
// 						const newFollowUp = Shark.getInstance("ClientFollowUp", {
// 							body: newQuotation.revision === 0 ? "Caricato il Preventivo '" + currQuotationData.number + "' per la Scheda Informativa '" + currSiteInfoSheet.getAutoFolderName() + "'." : "Aggiunta revisione per il Preventivo '" + currQuotationData.number + "'.",
// 							clientGuid: newQuotation.clientGuid,
// 							referenceGuid: newQuotation.guid,
// 							referenceType: "quotation",
// 							status: 3,
// 							type: "system"
// 						});
// 						console.log({newFollowUp});
				
// 						followUpManager.save(newFollowUp)
// 						.then(followUpSaveResponse => {
// 							console.log({followUpSaveResponse});
// 						});
// 					});
					
// 					break;
// 				}
// 				case 95:
// 					// let data = {
// 					// 	tempFile: savedFile.errors[0].erroData.tempFile,
// 					// 	originalName: savedFile.errors[0].erroData.originalName,
// 					// 	type: "pictureURL"
// 					// };
// 					// siteInfoSheetManager.emit("fileAlreadyPresentError", data);
// 					break;
// 				default:
// 					alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
// 			}
// 		});

// 		//Shark.render();
// 		return {};
// 	});
// });

Shark.registerController(siteInfoSheetManager);

export { siteInfoSheetManager };
